import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { dotPath } from 'ramdasauce'
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'

import { useStyles } from './styles'

export const ProductImages = ({ images }) => {
  const classes = useStyles()

  const length = images.length

  const imageCarousel = () => {
    return (
      <CarouselProvider
        naturalSlideHeight={1}
        naturalSlideWidth={1}
        totalSlides={length}
        className={classes.carousel}
      >
        <Slider
          className={classes.slider}
          classNameTrayWrap={classes.slider}
          classNameTray={classes.slider}
        >
          {renderSlides(images)}
        </Slider>
        <DotGroup className={classes.dots} />
      </CarouselProvider>
    )
  }

  const renderSlides = (images) => {
    return images.map((image, i) => {
      return (
        <Slide
          key={i}
          index={i}
          className={classes.slide}
          innerClassName={classes.slideInner}
        >
          <div className={classes.imageWrapper}>
            <GatsbyImage
              image={getImage(image.asset)}
              alt={dotPath('title', image)}
              className={classes.carouselImage}
            />
          </div>
        </Slide>
      )
    })
  }

  const singleImage = () => {
    return (
      <GatsbyImage
        image={getImage(images[0])}
        alt={dotPath('title', images[0])}
        className={classes.image}
      />
    )
  }

  return length === 1 ? singleImage() : imageCarousel()
}
